import React from 'react';

const Twitter = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#0F161E"
      d="M4.857 2A2.86 2.86 0 002 4.857v14.286A2.86 2.86 0 004.857 22h14.286A2.86 2.86 0 0022 19.143V4.857A2.86 2.86 0 0019.143 2H4.857zM18.12 5.75l-4.633 5.295 5.45 7.205H14.67l-3.34-4.37-3.826 4.37h-2.12l4.955-5.665L5.112 5.75h4.375l3.022 3.996L16 5.75h2.12zm-1.687 11.232L8.848 6.951H7.585l7.67 10.031h1.178z"
     />
  </svg>
);

export default Twitter;
